import { Trans } from '@lingui/macro';
import React from 'react';

import { Button } from '@components';

export type SessionExpiredProps = {
    onSignIn: () => any
};

export function SessionExpired ({ onSignIn }: SessionExpiredProps) {
    return (
        <>
            <h3 data-testid={'session-expired'}>
                <Trans id={'session.expired'} />
            </h3>

            <Button data-testid={'signin-button'} onClick={onSignIn}>
                <Trans id={'signIn'} />
            </Button>
        </>
    );
}
